import { useMutableRef } from '@carnica/utils/hooks';
import { format as _format, isValid, parse as _parse } from 'date-fns-new';
import { useCallback, useMemo } from 'react';
import { getMonthFromString, getPartDate, getParts, getValidSingleValue, monthFormat } from "./utils";
export var useMonthInput = function useMonthInput(params) {
  var valueProp = params.value,
    onChangeProp = params.onChange,
    disableDates = params.disableDates,
    maxDate = params.maxDate,
    minDate = params.minDate;
  var onChangeRef = useMutableRef(onChangeProp);
  var valueRef = useMutableRef(valueProp);
  var onChange = useCallback(function (stringValue, e) {
    var value = valueRef.current;
    if (value && isValid(value) && _format(value, monthFormat) === stringValue) {
      return;
    }
    if ((stringValue === null || stringValue === void 0 ? void 0 : stringValue.length) !== monthFormat.length && value && e) {
      var _onChangeRef$current;
      (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 ? void 0 : _onChangeRef$current.call(onChangeRef, null, e);
      return;
    }
    if (e) {
      if (!stringValue) {
        if (value) {
          var _onChangeRef$current2;
          (_onChangeRef$current2 = onChangeRef.current) === null || _onChangeRef$current2 === void 0 ? void 0 : _onChangeRef$current2.call(onChangeRef, null, e);
        }
        return;
      }
      var date = getMonthFromString(stringValue);
      if (date) {
        var _onChangeRef$current3;
        (_onChangeRef$current3 = onChangeRef.current) === null || _onChangeRef$current3 === void 0 ? void 0 : _onChangeRef$current3.call(onChangeRef, getValidSingleValue(date, minDate, maxDate, disableDates), e);
      } else if (value) {
        var _onChangeRef$current4;
        (_onChangeRef$current4 = onChangeRef.current) === null || _onChangeRef$current4 === void 0 ? void 0 : _onChangeRef$current4.call(onChangeRef, null, e);
      }
    }
  }, [minDate === null || minDate === void 0 ? void 0 : minDate.getTime(), maxDate === null || maxDate === void 0 ? void 0 : maxDate.getTime(), disableDates]);
  var maskOptions = useMemo(function () {
    return {
      mask: Date,
      pattern: monthFormat,
      format: function format(date) {
        return _format(date, monthFormat);
      },
      parse: function parse(string) {
        return _parse(string, monthFormat, new Date());
      },
      validate: function validate(string) {
        var formatArray = getParts(monthFormat);
        var valueArray = getParts(string);
        var validArray = formatArray.map(function (marker) {
          return getPartDate(formatArray, valueArray, marker);
        }).filter(function (item) {
          return Boolean(item);
        });
        return !(formatArray.length === validArray.length && !isValid(_parse(valueArray.join('.'), formatArray.join('.'), new Date())));
      }
    };
  }, []);
  return {
    onChange: onChange,
    maskOptions: maskOptions
  };
};